<template>
  <title-slot :title="tagsTitle"
              :type-title="'big'">
    <autocomplete-multiple :items="tagsComputed"
                           :value="activeTags"
                           :disabled="isLoading"
                           :info-select="infoSelect"
                           @changeValue="value => $emit('changeTags', value.value)"/>

    <div class="tags-container" v-if="tagsOut.length > 0">
      <label-custom v-for="item in activeTags"
                    @closeLabel="$emit('closeTags', item.id)"
                    :label-text="item.title"/>
    </div>
  </title-slot>
</template>

<script>
import TitleSlot from "@/components/entities/TitleSlot.vue";
import InputMain from "@/components/shared/input/InputMain.vue";
import AutocompleteMultiple from "@/components/shared/AutocompleteMultiple.vue";
import {mapActions, mapState} from "vuex";
import LabelCustom from "@/components/shared/LabelCustom.vue";
import {api} from "@/middleware/api";

export default {
  name: "TagsBlock",
  components: {LabelCustom, AutocompleteMultiple, InputMain, TitleSlot},
  props: {
    lang: {
      type: String,
      default: 'RU'
    },
    tagsTitle: {
      type: String,
      default: 'Добавить теги'
    },
    tagsOut: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      infoSelect: {
        key: 'select',
        placeholder: 'Начните вводить название тега'
      }
    }
  },
  created() {
    this.fetchInfo();
  },
  methods: {
    ...mapActions('tags', ['FETCH_TAGS']),
    async fetchInfo() {
      try {
        this.isLoading = true;
        let response = await api.dashboard.adminTagsControllerFindMany()
        this.FETCH_TAGS(response.data.items)
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false;
      }
    }
  },
  computed: {
    ...mapState('tags', ['tags']),
    activeTags() {
      return this.tagsComputed.filter(item => this.tagsOut.includes(item.id))
    },
    tagsComputed() {
      return this.tags.map(item => {
        let valueRU = item.translations?.find(item => item.langCode === 'RU')?.content;
        let valueEN = item.translations?.find(item => item.langCode === 'EN')?.content;
        return {
          id: item.id,
          title: valueEN ? `${valueRU} | ${valueEN}` : valueRU,
          value: item?.id,
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.title-slot-container {
  row-gap: 32px;
  .tags-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    column-gap: 8px;
  }
}
</style>